import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const HeaderContainer = styled.header`
  background: linear-gradient(135deg, #1B5E20 0%, #2E7D32 100%);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
`;

export const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  min-width: 0;
  
  @media (max-width: 1024px) {
    padding: 0 15px;
  }
`;

export const Logo = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: white;
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 1;
  
  &:hover {
    color: #E8F5E8;
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: linear-gradient(135deg, #1B5E20 0%, #2E7D32 100%);
    flex-direction: column;
    padding: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
`;

export const NavList = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 20px;
  align-items: center;
  flex-wrap: nowrap;
  
  @media (max-width: 968px) {
    gap: 15px;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const NavItem = styled.li`
  position: relative;
`;

export const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  white-space: nowrap;
  display: inline-block;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #E8F5E8;
  }
  
  &.active {
    background-color: rgba(255, 255, 255, 0.2);
    color: #E8F5E8;
  }
  
  @media (max-width: 768px) {
    display: block;
    width: 100%;
    text-align: center;
    padding: 12px;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 8px;
  
  @media (max-width: 768px) {
    display: block;
  }
  
  &:hover {
    color: #E8F5E8;
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  color: white;
  font-size: 0.9rem;
  
  @media (max-width: 968px) {
    display: none;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  
  svg {
    width: 16px;
    height: 16px;
  }
`;
